module.exports = __webpack_public_path__ + "static/media/navigationElectronics.7552273d.jpg";